// 印尼语
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "Riwayat",
    emptyRecords: "Belum ada riwayat Fruit Roulette",
    guessResult: "Hasil tebakan",
    myGuesses: "Tebakan saya",
    guessFailed: "Tebakan salah",
    winningPlayers: "Pemain pemenang",
    noGuesses: "Anda tidak menebak pada putaran ini",
    noWinners: "Tidak ada pemenang pada putaran ini",
    rulesTitle: "Cara bermain",
    rulesDescription: "Setiap putaran memberi waktu 50 detik untuk menebak buah yang akan muncul. Tebakan yang benar akan mendapatkan hadiah embun sesuai buahnya.",
    guessingTitle: "Cara menebak",
    guessingDescription: "Selama waktu menebak, pilih jumlah embun yang ingin dipertaruhkan, lalu ketuk area taruhan buah di layar untuk memasang tebakan.",
    rewardsTitle: "Hadiah",
    rewardsDescription: "Buah yang berbeda memberikan hadiah embun yang berbeda.",
    fruit: "Buah",
    multiplier: "Pengali hadiah",
    apple: "Apel",
    watermelon: "Semangka",
    orange: "Jeruk",
    banana: "Pisang",
    grape: "Anggur",
  },
  setPresident: {
    intro: "Anda dapat menunjuk ketua untuk membantu mengelola klub Anda",
    selfIntro: "Anda adalah ketua klub",
    president: "Ketua",
    empty: "Belum ada ketua",
    appoint: "Tunjuk",
    privileges: "Wewenang Ketua",
    privilegesIntro: "Ketua memiliki wewenang berikut",
    title: "Tunjuk Ketua",
    selectMember: "Pilih anggota yang ingin ditunjuk sebagai ketua",
    member: "Anggota",
    attendance: "Hadir {days} hari",
    weekContribution: "Kontribusi reputasi (minggu):",
    monthContribution: "(bulan):",
    confirmAppoint: "Tunjuk anggota ini sebagai ketua?",
    confirm: "Konfirmasi",
    remove: "Copot Jabatan",
    cancel: "Batal",
    removeTitle: "Copot Ketua Klub",
    confirmRemove: "Copot {name} dari jabatan ketua klub?",
    unnamed: "Tanpa nama",
    pkTitle: "Ruang PK",
    pkDesc: "Ketua dapat membuka, menutup, dan mengelola ruang PK klub",
    infoTitle: "Informasi Klub",
    infoDesc: "Ketua dan pemilik klub dapat mengedit sampul, nama, deklarasi, dan informasi klub lainnya",
    membersTitle: "Pengelolaan Anggota",
    membersDesc: "Ketua dan pemilik klub dapat mengeluarkan anggota dan tamu klub",
    rewardsTitle: "Hadiah Klub",
    rewardsDesc: "Ketua dapat mengklaim hadiah klub. Hadiah tidak dapat diklaim jika belum ada ketua",
    moderationTitle: "Moderasi Ruang Siaran",
    moderationDesc: "Ketua otomatis mendapatkan wewenang moderasi di ruang siaran pemilik klub",
    newPlayersTitle: "Kanal Pemain Baru",
    newPlayersDesc: "Ketua dan pemilik klub dapat melihat kanal pemain baru",
    loadMembersFailed: "Gagal memuat daftar anggota",
    appointFailed: "Gagal menunjuk ketua",
    appointSuccess: "Ketua berhasil ditunjuk",
    removeFailed: "Gagal mencopot ketua",
    removeSuccess: "Ketua berhasil dicopot",
    customerService: "Layanan Pelanggan",
    loadClubFailed: "Gagal memuat informasi klub",
  },
  /* 总榜单 */
  allRank: {
    lang1: "Penyiar radio",
    lang2: "Kaya",
    lang3: "PK",
    lang4: "Pertempuran klub",
    lang5: "Cina",
    lang6: "Bahasa inggris",
    lang7: "Thai",
    lang8: "Jepang",
    lang9: "bahasa Indonesia",
    lang10: "Orang Vietnam",
    lang11: "Jam",
    lang12: "Sehari-hari",
    lang13: "Mingguan",
    lang14: "minggu ini",
    lang15: "Minggu lalu",
    lang16: "Bulanan",
    lang17: "Daftar Peringkat",
    lang18: "Hadiah",
    lang19: "Tingkat koneksi",
    lang20: "Poin klub",
    lang21: "Anggota",
    lang22: "Tidak ada data",
    lang23: "Belum terdaftar",
    lang24: "Klub penggemar",
    lang25: "Tanggal",
    lang26: "Tidak bisa mengikuti diri sendiri",
    lang27: "Ikuti dengan sukses",
    lang28: "Berhenti mengikuti dengan sukses",
    lang29: "Menunggu",
    lang30: "kemarin",
    lang31: "Bulan lalu",
    lang32: "Tidak di daftar",
    lang33: "Rangkatku",
    lang34: "Utusan",
    lang35: "Daftar Hadiah Bulanan",
    lang36: "Daftar bulanan murid",
    lang37: "Club",
    lang38: "Grup Penggemar",
    lang39: "Tidak ada slogan",
    lang40: "Anggota",
    lang41: "Anggota",
    lang42: "Reputasi Minggu",
    lang43: "Reputasi total",
    lang44: "Peringkat Klub",
    lang45: "Bagikan",
    lang46: "Luncurkan",
    lang47: "mengirim undangan Klub",
    lang48: "Luncurkan FIREFLY agar lebih seru siaran langsung",
    lang49: "Peringkat Hadiah Mingguan",
    lang50: "Peringkat Jumlah Mingguan",
    lang51: "Reputasi",
    lang52: "Hadiah",
  },

  /* 俱乐部 */
  club: {
    lang1: "Penyiar radio",
    lang2: "Kaya",
    lang3: "PK",
    lang4: "Pertempuran klub",
    lang5: "Cina",
    lang6: "Bahasa inggris",
    lang7: "Thai",
    lang8: "Jepang",
    lang9: "bahasa Indonesia",
    lang10: "Orang Vietnam",
    lang11: "Jam",
    lang12: "Sehari-hari",
    lang13: "Mingguan",
    lang14: "minggu ini",
    lang15: "Minggu lalu",
    lang16: "Bulanan",
    lang17: "Daftar Peringkat",
    lang18: "Hadiah",
    lang19: "Tingkat koneksi",
    lang20: "Poin klub",
    lang21: "Anggota",
    lang22: "Tidak ada data",
    lang23: "Belum terdaftar",
    lang24: "Klub penggemar",
    lang25: "Tanggal",
    lang26: "Tidak bisa mengikuti diri sendiri",
    lang27: "Ikuti dengan sukses",
    lang28: "Berhenti mengikuti dengan sukses",
    lang29: "Menunggu",
    lang30: "Graf Kontribusi Titik",
    lang31: "peringkat",
    lang37: "Club",
    lang38: "Grup Penggemar",
    lang39: "Tidak ada slogan",
    lang40: "Anggota",
    lang41: "Anggota",
    lang42: "Reputasi Minggu",
    lang43: "Reputasi total",
    lang44: "Peringkat Klub",
    lang45: "Bagikan",
    lang46: "Luncurkan",
    lang47: "mengirim undangan Klub",
    lang48: "Luncurkan FIREFLY dan gabung klub untuk seru-seruan~",
    lang49: "Grup Penggemar",
    lang50: "Lord: ",
    lang51: "Presiden: ",
    // Label peran pada baris "Peringkat Saya" di halaman peringkat klub.
    lang52: "Penguasa",
    lang53: "Ketua",
    lang54: "Anggota",

    lang55: "Belum ada klub afiliasi",

    lang56: "Klub afiliasi belum diatur",
  },

  /* 榜单 */
  rank: {
    lang1: "Penyiar radio",
    lang2: "Kaya",
    lang3: "PK",
    lang4: "Pertempuran klub",
    lang5: "Cina",
    lang6: "Bahasa inggris",
    lang7: "Thai",
    lang8: "Jepang",
    lang9: "bahasa Indonesia",
    lang10: "Orang Vietnam",
    lang11: "Jam",
    lang12: "Sehari-hari",
    lang13: "Mingguan",
    lang14: "minggu ini",
    lang15: "Minggu lalu",
    lang16: "Bulanan",
    lang17: "Daftar Peringkat",
    lang18: "Hadiah",
    lang19: "Tingkat koneksi",
    lang20: "Poin klub",
    lang21: "Anggota",
    lang22: "Tidak ada data",
    lang23: "Belum terdaftar",
    lang24: "Klub penggemar",
    lang25: "Tanggal",
    lang26: "Tidak bisa mengikuti diri sendiri",
    lang27: "Ikuti dengan sukses",
    lang28: "Berhenti mengikuti dengan sukses",
    lang29: "Menunggu",
    lang30: "kemarin",
    lang31: "Bulan lalu",
    lang32: "Tidak di daftar",
    lang33: "Rangkatku",
    newDraw96: "Panggilan pribadi",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY TOP Center",
    playerCoreTitle: "Player Core TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Broadcaster Core TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Rankings",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Broadcaster Rankings",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Broadcaster Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Car Ranking",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "Firefly Garden Ranking",
    firstLoveBoard: "FirstLove Ranking",
    newStarBoard: "New Star Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private Credit Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "Penyiar radio",
    lang2: "Kaya",
    lang3: "PK",
    lang4: "Pertempuran klub",
    lang5: "Cina",
    lang6: "Bahasa inggris",
    lang7: "Thai",
    lang8: "Jepang",
    lang9: "bahasa Indonesia",
    lang10: "Orang Vietnam",
    lang11: "Jam",
    lang12: "Sehari-hari",
    lang13: "Mingguan",
    lang14: "minggu ini",
    lang15: "Minggu lalu",
    lang16: "Bulanan",
    lang17: "Daftar Peringkat",
    lang18: "Hadiah",
    lang19: "Tingkat koneksi",
    lang20: "Poin klub",
    lang21: "Anggota",
    lang22: "Tidak ada data",
    lang23: "Belum terdaftar",
    lang24: "Klub penggemar",
    lang25: "Tanggal",
    lang26: "Tidak bisa mengikuti diri sendiri",
    lang27: "Ikuti dengan sukses",
    lang28: "Berhenti mengikuti dengan sukses",
    lang29: "Menunggu",
    lang30: "Graf Kontribusi Titik",
    lang31: "peringkat",
    lang37: "Club",
    lang38: "Grup Penggemar",
    lang39: "Tidak ada slogan",
    lang40: "Anggota",
    lang41: "Anggota",
    lang42: "Reputasi Minggu",
    lang43: "Reputasi total",
    lang44: "Peringkat Klub",
    lang45: "Bagikan",
    lang46: "Luncurkan",
    lang47: "mengirim undangan Klub",
    lang48: "Luncurkan FIREFLY agar lebih seru siaran langsung",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "Hargai catatan nilai",
    income10: "Bulan ini",
    income11: "Bulan lalu",
    news7: "Hal-hal",
    news13: "Fan Value",
    cashreal6: "Batal",
    box1: "Belum ada catatan",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "Intro klub",
    lang2:
      "Klub adalah grup yang terdiri dari penggemar inti pembawa acara. Dengan bergabung dalam klub, Anda dapat berpartisipasi dalam acara dan kompetisi yang menyenangkan bersama, dan berteman dengan anggota di klub yang sama. Jumlah grup penggemar dan reputasi adalah poin kompetitif utama klub, dan keduanya melambangkan pengaruh dan popularitas pembawa acara pendiri.",
    lang3: "Pengenalan atribut khusus klub",
    lang4: "Kreator C.by:",
    lang5:
      "Pendiri klub, biasanya pembawa acara. Pembawa acara akan membuka klub setelah jumlah orang yang diikutinya mencapai jumlah tertentu.",
    lang6: "Presiden P.by:",
    lang7:
      "Manajer klub akan berlaku setelah ditunjuk oleh tuan rumah. Presiden klub juga menjadi manajer ruang siaran langsung kreator C.by.",
    lang8: "Anggota:",
    lang9:
      'Anggota klub. Cara bergabung adalah dengan mengirimkan hadiah "Cherish You" atau "Cherish Together" selama siaran langsung. Tidak ada batasan jumlah anggota di klub mana pun.',
    lang10: "Hadiah eksklusif:",
    lang11:
      "Kompetisi klub dengan hadiah khusus. Kirim hadiah klub untuk mendapatkan poin klub.",
    lang12: "Poin klub:",
    lang13:
      "1. Kirim hadiah eksklusif klub di ruang siaran langsung pendiri klub untuk mengumpulkan poin klub. 2. Selesaikan tugas klub harian di ruang siaran langsung pendiri klub untuk mengumpulkan poin klub.",
    lang14: "Reputasi:",
    lang15:
      "Jumlah poin klub dari semua anggota di klub yang sama adalah reputasi klub. Jumlah poin klub yang ditingkatkan oleh semua anggota di klub setiap minggu adalah reputasi mingguan klub. Kotak obrolan eksklusif",
    lang16: "Level anggota",
    lang17:
      "1. Proses pengumpulan poin klub adalah proses menyelesaikan peningkatan. Silakan lihat ikon di atas untuk detailnya. 2. Mengirim hadiah klub. 1 permata = 1 poin Klub (tidak memengaruhi atribut hadiah lainnya). 3. Poin klub tidak akan bertambah lagi setelah mencapai batas atas pada hari tersebut.",
    lang18: "Penurunan level anggota",
    lang19:
      "1. Di klub, ketika seorang anggota tidak menyumbangkan poin klub selama 3 hari berturut-turut, poin klub akan mulai berkurang sejak hari ke-4. 2. Penurunan poin klub yang terus-menerus akan menyebabkan anggota tersebut diturunkan levelnya. Silakan lihat level anggota untuk detailnya. 3. Jika poin klub turun menjadi 0, anggota tersebut akan secara otomatis keluar dari klub.",
    lang20: "Hak istimewa anggota",
    lang21: "lainnya",
    lang22:
      "Jika klub memiliki akun palsu, curang, atau memiliki nama atau kedok yang melanggar hukum dan peraturan setempat, platform FIREFLY berhak mengubah atau menghapus klub.",
    lang23: "Level klub",
    lang24: "Poin yang diperlukan untuk peningkatan",
    lang25: "Daily bonus",
    lang26: "Batas atas poin klub",
    lang27: "Atenuasi",
    lang28: "Hak istimewa",
    lang29: "Keterangan",
    lang30: "Papan nama klub",
    lang31: "Identifikasi level khusus di ruang siaran langsung kreator C.by",
    lang33: "Hadiah eksklusif di ruang siaran langsung kreator C.by",
    lang34: "Kotak obrolan eksklusif",
    lang35: "Kotak obrolan eksklusif di ruang siaran langsung kreator C.by",
    lang36: "Kotak harta karun klub",
    lang37:
      "Anda dapat memperoleh hak istimewa kotak harta karun klub di ruang siaran langsung kreator C.by",
    lang38: "Daily bonus",
    lang39:
      "Anda dapat menyelesaikan tugas harian di ruang siaran langsung kreator C.by untuk menerima paket hadiah.",
    lang40: "Obrolan anggota",
    lang41:
      "Obrolan dengan semua anggota klub melalui pesan pribadi tanpa batasan keintiman",
    lang42: "Segar",
    lang43: "Layanan Pelanggan",
    lang44: "Tutup Halaman",
    lang45: "Klub",
    lang46: "Club",
    lang47:
      "Klub adalah komunitas eksklusif yang dibentuk bersama oleh pemain dan penguasa. Bergabunglah dan sumbangkan reputasi untuk membantu klub bersaing meraih kehormatan serta hadiah peringkat eksklusif!",
    lang48: "Afiliasi klub",
    lang49:
      "Setiap pemain dapat menetapkan maksimal satu klub sebagai klub afiliasinya. Setelah ditetapkan, peran Anda di klub tersebut berubah menjadi 「Anggota」. Reputasi dari prestasi (seperti juara peringkat dan juara ajang bakat malam) serta kemenangan permainan di ruang PK akan otomatis disumbangkan ke klub afiliasi Anda.",
    lang50: "Bergabung/keluar klub",
    lang51:
      "Pemain bergabung dengan klub penguasa dengan mengirimkan hadiah 「Lonceng Yingxin」 kepada penguasa. Setelah bergabung melalui hadiah, peran Anda adalah 「Tamu」. Pemain bebas memilih untuk keluar dari klub.",
    lang52: "Reputasi",
    lang53:
      "Reputasi adalah inti persaingan antarklub. Semua orang di klub menyumbangkan reputasi dengan menyelesaikan tugas klub, bersaing menjadi juara acara peringkat, serta mengikuti dan memenangkan permainan.",
    lang54: "Hadiah klub",
    lang55:
      "Hadiah yang dimenangkan klub dalam kompetisi akan diberikan kepada ketua klub. Klub yang belum menetapkan ketua tidak dapat menerima hadiah klub.",
    lang56: "Peringkat klub",
    ranked: "Sudah masuk peringkat",
    lang57:
      "Klub yang memenuhi syarat berikut dapat mengikuti peringkat FIREFLY Club:",
    lang58: "Mengubah nama klub",
    lang59: "Mengubah sampul klub",
    lang60: "Menetapkan ketua",
    lang61:
      "Klub yang belum memenuhi syarat tetap dapat menerima pemain dan mengumpulkan reputasi, tetapi tidak dapat mengikuti peringkat.",
    lang62: "Peran klub",
    lang63: "Club Role",
    lang64: "Penguasa",
    lang65:
      "Penguasa adalah pendiri klub dan terikat erat dengan klub. Penguasa memiliki wewenang untuk mengelola dan mengedit klub serta menetapkan ketua.",
    lang66: "Ketua",
    lang67:
      "Ditunjuk oleh penguasa, ketua memiliki wewenang untuk mengelola dan mengedit klub serta membuka ruang PK klub.",
    lang68:
      "<span class='highlight-text'>Hadiah klub: </span>Semua hadiah untuk klub diberikan kepada ketua. Klub yang belum menetapkan ketua tidak dapat menerima hadiah klub.",
    lang69: "Anggota",
    lang70:
      "Pemain yang telah bergabung dan menetapkan klub tersebut sebagai 「klub afiliasinya」. Hadiah reputasi dari prestasi dan permainan otomatis disumbangkan ke klub afiliasi mereka.",
    lang71: "Tamu",
    lang72:
      "Pemain yang telah bergabung dengan klub, tetapi belum menetapkannya sebagai 「klub afiliasi」.",
    lang73: "Klub Juara",
    lang74:
      "Pemenang peringkat klub mingguan FIREFLY menjadi 「Klub Juara」 pada minggu berikutnya. Selama periode ini, tamu tidak dapat menetapkan Klub Juara sebagai klub afiliasi. Nama klub akan ditampilkan untuk anggotanya di semua ruang siaran langsung.",
    lang75: "Lainnya",
  },

  /* 极速狂飙 */
  kingOfSpeed: {
    lang1: "Aturan Permainan",
    lang2: "Deskripsi Permainan",
    lang3:
      "1. Lempar dadu: Setiap klik pada Lempar dadu membutuhkan 1000 DEW. Melempar dadu akan memberikan bonus untuk mobil tim.",
    lang4:
      "2. Probabilitas Dadu: Probabilitas masing-masing dari enam efek yang ditarik adalah sama, tetapi efek bonus pada masing-masing dari enam sisi berbeda.",
    lang5:
      "3. Hasil Permainan: Di akhir waktu PK permainan, tim dengan jarak lebih tinggi menang, dan tim dengan jarak lebih rendah kalah. Jika kedua tim memiliki jarak yang sama, maka seri.",
    lang6: "Deskripsi Mobil",
    lang7:
      "1. Persyaratan Mobil: Jika penyiar tidak memiliki mobil di awal permainan, mobil tim saat ini tidak dapat dibentuk.",
    lang8: "Deskripsi level Qi",
    lang9:
      "1. Naik Level: Pemain berinteraksi satu sama lain untuk meningkatkan popularitas penyiar. Popularitas digunakan untuk meningkatkan level Qi tim. Semakin tinggi level Qi, semakin kuat efek bonus dadu.",
    lang10: "2. Persyaratan Level Qi:",
    lang11: "Level Dadu",
    lang12: "Popularitas",
    lang13: "Deskripsi DEWs Pool",
    lang14:
      "1. DEWs Pool: DEW dari dadu yang dilempar oleh kedua pemain akan terakumulasi ke dalam DEWs Pool. Di akhir permainan, tim pemenang akan menerima semua DEW di pool sebagai hadiah. Jika seri, pemain dari kedua tim akan menerima hadiah dari Pool DEW.",
    lang15:
      "2. Distribusi Hadiah: Hadiah didistribusikan berdasarkan persentase DEWs dari lemparan dadu setiap pemain di tim pemenang. Pemain yang tidak melempar dadu untuk berpartisipasi dalam permainan tidak berpartisipasi dalam distribusi hadiah Dew Pool.",
    lang16:
      "3. Biaya Layanan: Pemain menerima hadiah dari DEWs Pool. Platform akan mengenakan biaya layanan sebesar 4%.",
    lang17: "Catatan Pengembangan Permainan",
    lang18:
      "1. Pemain dapat berpartisipasi dalam King of Speed ​​melalui PK dalam game mulai pukul 12:00 siang tanggal 23 Oktober 2025 hingga pukul 12:00 pagi tanggal 17 November 2025.",
    lang19: "Tindakan pencegahan",
    lang20: "1. Semua waktu dalam acara ini didasarkan pada waktu server.",
    lang21:
      "2. Untuk memastikan keadilan permainan, platform berhak untuk menyesuaikan atau menangguhkan segala kejanggalan dalam permainan karena faktor force majeure, seperti masalah jaringan, kecurangan, atau aktivitas tidak sah lainnya.",
    lang22:
      "3. Permainan ini Hanya untuk tujuan hiburan. Transaksi offline antar pemain atau penyiar dilarang keras. Waspadai penipuan atau upaya mendapatkan keuntungan ilegal.",
    lang23:
      "4. Platform tidak bertanggung jawab atas kerugian permainan yang disebabkan oleh masalah jaringan pribadi atau perangkat.",
    lang24: "5. Platform berhak atas interpretasi akhir permainan.",
    lang25: "Catatan Permainan PK",
    lang26: "Waktu PK",
    lang27: "Menggulirkan dadu",
    lang28: "Tim PK",
    lang29: "Jarak",
    lang30: "Hasil",
    lang31: "Memuat...",
    lang32: "Tidak ada lagi catatan",
    lang33: "Tidak ada catatan PK permainan",
    lang34: "Penyiar lainnya tidak memiliki mobil.",
    lang35: "Tim biru tidak memiliki mobil",
    lang36: "Tim Merah tidak memiliki mobil.",
    lang37: "Batas kecepatan hingga",
    lang38: "Kecepatan",
    lang39: "Penyiar harus mendapatkan mobil untuk bergabung dalam permainan.",
    lang40: "Keberangkatan",
    lang41: "Tips",
    lang42:
      "Saat ini tidak memiliki mobil, jadi tidak dapat berpartisipasi dalam permainan PK",
    lang43: "Buka",
    lang44: "DEWs Pool",
    lang45: "Tim Kami",
    lang46: "Lawan",
    lang47: "Lempar",
    lang48: "Lempar Saya:",
    lang49: "Informasi hadiah",
    lang50: "1. DEWs Pool:",
    lang51:
      "DEWs dari dadu yang digulirkan oleh kedua pemain akan ditambahkan ke DEWs Pool. Di akhir permainan, tim pemenang akan menerima semua DEWs di DEWs Pool sebagai hadiah. Jika seri, kedua pemain",
    lang52: "2. Distribusi Hadiah:",
    lang53:
      "Hadiah didistribusikan berdasarkan persentase DEWs dari lemparan dadu setiap pemain di tim pemenang. Pemain yang tidak melempar dadu untuk berpartisipasi dalam permainan tidak akan berpartisipasi dalam distribusi hadiah DEWs Pool.",
    lang54: "3. Biaya Layanan:",
    lang55:
      "Pemain menerima hadiah dari DEWs Pool, dan platform akan mengenakan biaya layanan sebesar 4%.",
    lang56: "Oke",
    lang57: "Naikkan Kecepatan",
    lang58: "Perisai",
    lang59: "Serang",
    lang60: "Tim Merah",
    lang61: "Tim Biru",
    lang62: "Detail Mobil Balap",
    lang63: "Mengaktifkan",
    lang64: "Tidak aktif",
    lang65: "detik",
    lang66: "Percepat x2, terus menerus",
    lang67: "Melindungi",
    lang68: "Tidak terlindungi",
    lang69: "Perisai memberikan ketahanan terhadap efek negatif sekali.",
    lang70: "(Gangguan, Batas Kecepatan)",
    lang71: "Lanjutan",
    lang72: "Mengaktifkan",
    lang73: "Tidak aktif",
    lang74:
      "Ketika Nilai Pengisian Daya penuh, kecepatan mobil adalah x3, dan durasinya adalah",
    lang75: "Durasi Peningkatan Kecepatan",
    lang76: "Percepat",
    lang77: "Mode Turbo:",
    lang78: "Durasi perisai",
    lang79: "Gangguan",
    lang80: "Mode Interferensi:",
    lang81: "Batas kecepatan",
    lang82: "Perolehan Mobil",
    lang83:
      "Nilai Serang: Ketika Nilai Serang mencapai 100%, Mode Serang aktif. Kecepatan Pengisian Daya adalah x3, dan durasinya adalah",
    lang84: "Keluar setelah waktu habis.",
    lang85: "Mode Pengisian Daya",
    lang86: "Reset biaya",
    lang87: "Mobil akan mendapatkan peningkatan kecepatan.",
    lang88: "Berkelanjutan",
    lang89: "Kecepatan akan dipulihkan setelah waktu habis.",
    lang90: "Balap mendapatkan",
    lang91: "Bonus",
    lang92: "Kecepatan",
    lang93: "Berkelanjutan",
    lang94: "Tahan sekali",
    lang95: "Efek Negatif",
    lang96:
      "Ketika beberapa bonus perisai diberikan, tumpukan perisai akan ditumpuk. Setelah penghitung waktu berakhir atau kekebalan diterapkan, tumpukan perisai berkurang 1.",
    lang97: "Menggunakan efek disrupsi, menargetkan lawan.",
    lang98: "Interferensi",
    lang99: "Setelah berlaku, kecepatan normal mobil akan dikurangi.",
    lang100:
      "Gunakan efek Batas Kecepatan untuk memberikan tanda perlambatan kepada lawan, yang memperlambat mobil mereka.",
    lang101: "Gangguan",
    lang102: "Batas kecepatan",
    lang103: "Menggulirkan dadu",
    lang104: "Lempar dadu untuk mendapatkan bonus.",
    lang105: "Kebut! Berlari Cepat Bersama!",
    lang106:
      "Slogan telah disalin. Silakan tempel ke kotak input dan kirimkan!",
    lang107: "Salinan Gagal",
    lang108: "Berpartisipasi dalam permainan balap",
    lang110: "Penyiar memiliki mobil.",
    lang111: "Tercapai",
    lang112: "Tidak tercapai",
    lang113: "Bergabung dengan Tim PK",
    lang115: "Klik untuk mengirim mobil",
    lang116: "Klik untuk mengirim slogan tim",
    lang117: "Permainan saat ini tidak aktif, jadi dadu tidak dapat dilempar.",
    lang118: "Penyiar tidak diizinkan melempar dadu.",
    lang119: "Speed ​​Rush, pemenangnya menang!",
    lang120: "Permainan Belum Dimulai",
    lang121: "[King of Speed] tidak diaktifkan dan tidak dapat dimainkan.",
    lang122: "Balap mendapatkan perisai tambahan",
    lang123: "Tanpa kursi",
    lang124: "Pemimpin",
    lang125: "Terbelakang",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "Asisten Live",
    lang2:
      "Jika pemain terikat sebagai asisten Live, pemain akan menerima bagian FIRE yang Anda terima.",
    lang3: "Asisten Live Terikat",
    lang4: "Masukkan ID untuk mengonfirmasi pemain terikat",
    lang5: "Masukkan ID Pemain yang Ingin Anda Ikat",
    lang6: "Berikutnya",
    lang7: "Rasio pembagian FIRE",
    lang8: "Instruksi Pengikatan",
    lang9:
      "Setelah mengikat Asisten Live Anda, Asisten Live akan menerima bagian dari FIRE yang Anda kumpulkan. FIRE yang Anda kumpulkan melalui hadiah akan dikirimkan ke Asisten Live sesuai dengan rasio pembagian FIRE yang Anda tetapkan.",
    lang10: "Isi Ulang",
    lang11: "Ikat Asisten Live",
    lang12: "Konfirmasi Pengikatan?",
    lang13: "Asisten Live Anda",
    lang14: "Batal",
    lang15: "Menautkan berhasil",
    lang16: "Pengikatan gagal",
    lang17: "Melepas ikatan berhasil",
    lang18: "Melepas ikatan gagal",
    lang19:
      "Jika pemain terikat sebagai asisten Live, pemain akan menerima bagian FIRE yang Anda terima.",
    lang20: "Asisten Live Saya",
    lang21: "Lepas Ikatan",
    lang22: "Konfirmasi Tertunda",
    lang23: "Lepas Ikatan Asisten Live",
    lang24:
      "Melepas ikatan dari asisten Live memerlukan konfirmasi dari lawan bicara. Melepas ikatan?",
    lang25: "Asisten Live Anda?",
    lang26: "Lepas Ikatan Ditolak",
    lang27: "Lepas Ikatan Ditolak Gagal",
    lang28: "Pengaturan asisten Live",
    lang29: "FIREs Baru",
    lang30:
      "Lawan bicara telah melepaskan ikatan status asisten Live Anda; konfirmasi Anda diperlukan.",
    lang31: "Permintaan Lepas Ikatan",
    lang32:
      "Hal sebaliknya telah diterapkan untuk melepas ikatan akun Asisten Live Anda. Mohon konfirmasi.",
    lang33: "Tolak",
    lang34: "Daftar streamer yang mengikat saya sebagai asisten Live",
    lang35: "Belum ada streamer yang terikat",
    lang36: "Lepas Ikatan Asisten Live",
    lang37: "Melepas ikatan?",
    lang38: "Apa hubungan asisten Live Anda?",
    lang39: "Pengguna telah diblokir.",
    lang40: "Pencarian ID yang Anda masukkan gagal.",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang2: "Status Siaran Langsung",
    lang3: "Riwayat",
    lang4: "Anda telah mengundurkan diri dari entri hari ini",
    lang5: "Gagal Mengundurkan Diri dari Partisipasi Hari Ini",
    lang6: "Mengundurkan Diri dari Partisipasi",
    lang7: "Peringkat saya",
    lang8: "Kemenangan",
    lang9: "Petunjuk Kompetisi",
    lang10:
      "Penyiar yang melaju ke Semi-Final/Final harus siaran langsung dan tidak sedang berada di pertandingan PK lain pada waktu mulai yang ditentukan. Sistem kemudian akan secara otomatis memulai PK antara kedua penyiar tersebut.",
    lang11: "Semifinal",
    lang12: "Format Best-of-5, penyiar pemenang melaju ke Final",
    lang13: "Audisi No. 1 VS Audisi No. 4",
    lang14: "Audisi No. 2 VS Audisi No. 3",
    lang15: "Final",
    lang16:
      "Format Best-of-5, penyiar pemenang menjadi Juara 'Glow Night Showdown' hari itu",
    lang17: "Pemenang Semifinal",
    lang18:
      "Catatan: Jika Anda memenuhi persyaratan partisipasi untuk Semi-Final/Final tetapi tidak dapat bergabung, silakan klik di sini sebelum pukul 20.30 setiap hari.",
    lang20:
      "Ketidakhadiran dalam pertandingan akan mengakibatkan mereka tidak dapat berpartisipasi dalam acara 'Glow Night Showdown' selama 15 hari ke depan.",
    lang22:
      "Mengundurkan diri dari pertandingan akan menghapus Anda dari peringkat Audisi, dan kelayakan Anda akan dipulihkan keesokan harinya.",
    lang23: "Apakah Anda ingin mengundurkan diri dari partisipasi hari ini?",
    lang24: "Acara Firefly Glow Night Showdown",
    lang25: "Batal",
    lang26: "Isi Ulang",
    lang27: "Kemenangan",
    lang28: "DNF",
    lang29: "Tidak Ada Rekaman Sebelumnya yang Tersedia",
    lang30: "Berpartisipasilah dalam 'Glow Night Showdown'",
    lang31:
      "Penyiar yang menggunakan FIREFLY V54.0 atau lebih tinggi untuk memulai PK (termasuk 'PK Popularitas' dan 'PK Game') berhak berpartisipasi dalam acara Glow Night Showdown.",
    lang32: "Audisi",
    lang33: "Waktu: Setiap Hari 20.30 - 20.30 keesokan harinya",
    lang34:
      "Aturan: Papan peringkat mencatat Nilai Popularitas tertinggi yang dicapai oleh penyiar dalam pertandingan PK mereka pada hari tersebut, dan peringkat didasarkan pada nilai maksimum ini.",
    lang35:
      "Langkah Lanjut: 4 penyiar teratas dalam peringkat Audisi sebelum pukul 20:30 setiap hari akan maju ke Semifinal.",
    lang36:
      "Keikutsertaan Dibatalkan: Jika seorang penyiar tidak dapat melakukan siaran langsung selama waktu yang ditentukan untuk Semifinal/Final, mereka dapat memilih untuk mengundurkan diri selama periode Audisi. Penyiar dengan peringkat tertinggi berikutnya akan menggantikan mereka.",
    lang37: "Semifinal",
    lang38: "Waktu: Setiap hari pukul 21:00 / 21:20",
    lang39:
      "Aturan: Sistem akan secara otomatis memulai pertandingan PK antara dua penyiar Semifinal pada waktu yang ditentukan. Aturan PK adalah 'PK Popularitas' dalam format Best-of-5. Penyiar harus tetap siaran langsung selama waktu ini.",
    lang40: "Tahapan: Pemenang akan melaju ke Final",
    lang41:
      "Keikutsertaan Dibatalkan: Seorang penyiar dianggap mengundurkan diri jika mereka tidak melakukan siaran langsung pada awal Semifinal. Mereka tidak akan menerima hadiah peringkat dan tidak berhak berpartisipasi dalam 'Glow Night Showdown' selama 15 hari ke depan.",
    lang42: "Ditentukan melalui undian acak oleh sistem setelah audisi harian berakhir",
    lang43: "Ditentukan melalui undian acak oleh sistem setelah audisi harian berakhir",
    lang44:
      "Peserta yang kalah di Semifinal akan diberi peringkat No. 3/No. 4 berdasarkan Nilai Popularitas tertinggi mereka hari itu.",
    lang45: "Final",
    lang46: "Waktu: Setiap hari pukul 22:00",
    lang47:
      "Aturan: Sistem akan secara otomatis memulai pertandingan PK antara dua penyiar Finalis pada waktu yang ditentukan. Aturan PK adalah 'PK Popularitas' dalam format Best-of-5. Penyiar harus tetap siaran langsung selama waktu ini.",
    lang48:
      "Kemajuan: Pemenang dinobatkan sebagai Juara 'Glow Night Showdown' hari itu.",
    lang49:
      "Mengundurkan Diri: Penyiar dianggap mengundurkan diri jika tidak tampil langsung di awal Final. Mereka tidak akan menerima hadiah peringkat dan tidak berhak berpartisipasi dalam 'Glow Night Showdown' selama 15 hari ke depan.",
    lang50:
      "Pemenang Final adalah Juara hari itu, dan yang kalah adalah Juara 2 hari itu.",
    lang51: "Hadiah",
    lang52: "Hadiah DEWs Pemain:",
    lang53: "Semifinal 1: Tim pemenang akan membagi",
    lang54: "Semifinal 2: Tim pemenang akan membagi",
    lang55: "Final: Tim pemenang akan membagi",
    lang56: "Hadiah Poin Penyiar:",
    lang57:
      "Setelah pemenang ditentukan, 4 penyiar teratas akan menerima poin untuk 'Hadiah Livestream'. Penyiar yang mengundurkan diri tidak akan menerima hadiah poin. Silakan periksa di sini untuk poin spesifik.",
    lang58: "Hadiah siaran langsung>",
    lang59: "Tindakan pencegahan",
    lang60: "1. Acara ini terbatas pada jangkar wanita",
    lang61:
      "2. Selama periode pembatasan partisipasi Anda dalam aktivitas ini, semua data aktivitas akan menjadi tidak valid dan harus dikumpulkan kembali setelah pembatasan dicabut.",
    lang62:
      "3. Streamer harus aktif berinteraksi dengan pemain. Platform berhak untuk mendiskualifikasi streamer dan mencabut poin aktivitas mereka atas perilaku apa pun yang melanggar \"Perjanjian Streamer\" atau mengganggu keseimbangan acara (termasuk tetapi tidak terbatas pada: siaran yang memperlihatkan wajah, siaran berkualitas rendah, layar hitam, siaran AFK, siaran sambil bermain game, menonton TV, bersekongkol dalam hasil PvP, dan bermain pasif). Streamer yang melanggar aturan di atas akan dikenakan 'sanksi kartu merah' oleh platform.",
    lang63: "4. Platform berhak atas interpretasi akhir untuk acara ini.",
    lang64: "Dalam Audisi",
    lang65: "20.30 - 20.30 keesokan harinya",
    lang66:
      "Mulai PK untuk berpartisipasi dalam peringkat Audisi. Papan mencatat Nilai Popularitas PK tertinggi hari itu, dan 4 teratas akan melaju ke Semifinal.",
    lang67: "Zona Promosi",
    lang68: "Tidak Ada Rekaman Audisi yang Tersedia",
    lang69: "FIREFLY Anda telah memesan tempat untuk Final Glow Night Showdown",
    lang70: "Setiap hari pukul 21.00-23.00, pemenang PK menerima hadiah DEWs",
    lang71: "Penyiar Finalis Belum Ditentukan",
    lang72: "Penyiar Semifinal Belum Ditentukan",
    lang74: "Audisi NO. 1",
    lang75: "Audisi NO. 2",
    lang76: "Audisi NO. 3",
    lang77: "Audisi NO. 4",
    lang78: "Pengingat >",
    lang79: "Hadiah Tim Pemenang",
    lang80: "Best-of-5",
    lang81: "Peringkat Terkunci",
    lang82: "Belum ada peringkat",
    lang83:
      "'FIREFLY' Anda telah memesan semifinal pertunjukan bakat malam fluoresensi.",
    lang84: "'FIREFLY' Anda telah memesan semifinal Audisi Malam Fluoresen 2",
    lang85: "Memuat lebih banyak...",
    lang86: "Gulir ke bawah untuk memuat lebih banyak",
    lang87: "Tidak ada informasi lebih lanjut untuk saat ini.",
    lang88: "Hukuman kartu merah:",
    lang89:
      "a. Membatalkan kualifikasi hadiah untuk acara 'Audisi Malam Fluoresen' pada hari itu.",
    lang90:
      "b. Dilarang berpartisipasi dalam acara 'Audisi Malam Fluoresen' selama 5 hari ke depan",
    lang91: "Hadiah",
    lang92:
      "Streamer peringkat 1-4 dalam 'Fluorescent Night Audition' harian akan menerima hadiah",
    lang93: "Juara",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "Peringkat Lain",
    lang97: "Tidak Ada Hadiah",
    lang98: "Klaim",
    lang99: "Tidak mendapatkan hadiah Fluorescent Night Audition",
    lang100: "Sudah diklaim",
    lang101: "Anda telah mengklaim hadiah Fluorescent Night Audition",
    lang102: "Berhasil diklaim",
    lang103: "Streamer dapat menerima hadiah permata:",
    lang104: "Juara:",
    lang105: "Peringkat ke-2:",
    lang106: "Peringkat ke-3/4:",
    lang107: "Hadiah Final",
    lang108: "Hasil",
    lang109: "Hadiah",
    lang110: "Menang",
    lang111: "Kalah",
    lang112: "Tidak Selesai",
    lang123: "Tidak Ada Hadiah",
    lang124: "Hadiah Semi-Final",
    lang125: "Hadiah Preliminaries",
    lang126: "Hadiah Final",
    lang127:
      'Ikut serta dalam Final "Audisi Malam Berpendar", hadiah dapat diklaim setelah Final berakhir.',
    lang128: "Hadiah Semi-Final",
    lang129:
      'Ikut serta dalam Semi-Final "Audisi Malam Berpendar", hadiah dapat diklaim setelah Final berakhir.',
    lang130: "Hadiah Preliminaries",
    lang131:
      '8 Besar di "Final Audisi Malam" dapat mengklaim, didistribusikan setiap hari pukul 21:00.',
    lang132: "Belum Dimulai",
    lang133: "Dalam PK",
    lang134: "Berakhir",
    lang135: "Tidak ada hadiah yang tersedia untuk diklaim",
    lang136: "Anda sudah mengklaim hadiahnya",
    lang137: "Ikut serta dalam PK Audisi Malam Berpendar, menangkan ",
    lang138: "Klaim",
    lang139: "Diklaim",
    lang140: "Klaim Semua",
    lang141: "Hadiah Saya",
    lang142: "Sedang",
    lang143: "NO.1-NO.4",
    lang144: "Peringkat Preliminaries",
    lang145: "NO.5-NO.8",
    lang146: "Tidak Ada Hadiah",
    lang147: "Peringkat Lainnya",
    lang148: "Tidak Berpartisipasi",
    lang149: "Zona Hadiah",
    lang150:
      "Silakan perbarui aplikasi ke versi V57.0 atau lebih tinggi untuk mengklaim hadiah!",
    lang151: "Hasil Tahap",
    lang152:
      "Dapat diklaim setelah peringkat akhir Night Draft hari ini ditentukan",
    lang153: "Top 4 Audisi",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "Pemain baru yang mendaftar dalam 7 hari dan menyelesaikan event isi ulang 'Paket Hadiah Isi Ulang Pertama' akan menerima hadiah 'FirstLove'. Mengirim hadiah 'FirstLove' akan mengikat streamer ke FirstLove, dan komentar mereka di siaran langsung akan memiliki tag khusus. Setiap pemain hanya dapat mengikat satu akun FirstLove.",
    lang3: "Entri Paket Hadiah Isi Ulang Pertama",
    lang4: "Pengiriman Hadiah",
    lang5: "Peringkat Hadiah Pertama FirstLove",
    lang6:
      "Peringkat Hadiah Pertama FirstLove diurutkan berdasarkan jumlah hadiah pertama FirstLove yang diterima host. Semakin banyak yang diterima, semakin tinggi peringkatnya. Jika beberapa host menerima jumlah FirstLove yang sama,",
    lang7:
      "host yang lebih dulu mencapai jumlah tersebut akan mendapat peringkat lebih tinggi.",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "Hadiah harian",
    lang2: "Catatan Hadiah",
    lang3: "【Tugas Selamat Datang】",
    lang4: "Poin",
    lang5:
      "Selesaikan event 'Selamat Datang PK'; Anda dapat menerima maksimal 6000 poin per hari.",
    lang6: "Selamat Datang PK",
    lang7:
      "Dapatkan poin untuk setiap 'Selamat Datang PK' yang diselesaikan (1 jam) berdasarkan hasil PK.",
    lang8: "Acara",
    lang9: "Sudah Diperoleh",
    lang10: "Terima",
    lang11: "Diklaim",
    lang12: "Penukaran Poin",
    lang13: "Poin Saya",
    lang14: "Hadiah",
    lang15: "Tahap",
    lang16: "Poin Terakumulasi",
    lang19: "Hadiah Poin",
    lang20: "Hadiah Selamat Datang",
    lang21: "Event Selamat Datang PK harian dengan dukungan trafik eksklusif.",
    lang25: "Suka",
    lang26: "Tidak ada data yang tersedia",
    lang27: "Aturan Hadiah Selamat Datang",
    lang29:
      "Saat streamer baru memulai PK, mereka memilih 'Selamat Datang PK' dan memulai pencarian lawan. PK Selamat Datang bersaing untuk jumlah Suka yang diterima oleh kedua streamer.",
    lang30: "Cara mendapatkan LIKE:",
    lang31: "Dapatkan hadiah eksklusif untuk pemain baru",
    lang32: "Deskripsi Hadiah Eksklusif:",
    lang33: "Nama Hadiah:",
    lang34: "Cara Memperoleh:",
    lang35:
      "Pemain yang baru terdaftar akan menerima hadiah ini secara gratis, berlaku selama 48 jam. Anda dapat mengklaimnya dengan mengklik 'Hadiah Pendatang Baru' di ruang siaran langsung.",
    lang36: "Suka",
    lang37: "FirstLove",
    lang38:
      "Pemain baru yang menyelesaikan acara isi ulang 'Paket Hadiah Isi Ulang Pertama' dalam waktu 7 hari setelah pendaftaran akan menerima hadiah 'FirstLove'.",
    lang39: "Anda telah mengklaim poin hari ini.",
    lang40:
      "Tidak dapat mengklaim poin jika persyaratan hadiah tidak terpenuhi.",
    lang41: "Berhasil mengklaim Poin Hadiah Selamat Datang",
    lang42: "Dukungan Pengguna Selamat Datang",
    lang43:
      "Mengaktifkan 'Selamat Datang PK' akan memberi Anda dukungan trafik selamat datang. Pemain yang baru terdaftar selama periode Selamat Datang PK akan secara otomatis didorong ke ruang siaran langsung 'Selamat Datang PK'.",
    lang44: "Klaim Poin",
    lang45:
      "Selesaikan 'Hadiah Harian' untuk mendapatkan poin. Kumpulkan poin untuk mencapai level yang sesuai dan dapatkan Hadiah Firefly.",
    lang46: "Catatan",
    lang47: "1. Acara ini hanya terbuka untuk streamer wanita.",
    lang48:
      "3. Hanya satu akun per perangkat yang dapat mengklaim hadiah; beberapa akun yang mengklaim hadiah akan mengakibatkan diskualifikasi dan tidak akan diaktifkan kembali.",
    lang49:
      "4. Selama periode partisipasi terbatas, semua data acara tidak valid dan harus diambil kembali setelah pembatasan dicabut.",
    lang50:
      "5. Poin hadiah harian harus diklaim secara manual. Harap klaim sebelum pukul 12:00 siang pada tanggal 3 Desember 2025. Klaim yang terlambat tidak akan diterbitkan ulang.",
    lang51:
      "6. Akun yang sudah terhubung dengan pengundang tidak diperbolehkan membuat akun sekunder untuk streaming langsung dan mengklaim poin. Setelah ditemukan, semua akun akan didiskualifikasi dan kelayakan tidak akan dipulihkan.",
    lang52:
      "7. Akun tanpa pengundang tidak dikenakan pembatasan akun dan mungkin memenuhi syarat untuk berpartisipasi, tetapi hanya satu akun yang dapat berpartisipasi dalam acara hadiah.",
    lang53:
      "8. Streamer harus aktif berinteraksi dengan pemain. Untuk setiap perilaku yang melanggar 'Perjanjian Streaming Langsung Streamer' atau mengganggu keseimbangan acara, platform berhak untuk mendiskualifikasi streamer dan membatalkan poin acara mereka (termasuk tetapi tidak terbatas pada menggantung wajah, streaming berkualitas rendah, layar hitam, AFK, streaming permainan, menonton TV, dll.).",
    lang54: "9. Platform berhak atas interpretasi akhir dari acara ini.",
    lang55: "2. Durasi acara dihitung setiap dua menit.",
    lang57: "Menang",
    lang58: "Undian",
    lang59: "Kalah",
    lang60: "Tahap Hadiah 1",
    lang61: "Tahap Hadiah 2",
    lang62: "Tahap Hadiah 3",
    lang63: "Tahap Hadiah 4",
    lang64: "Level Hadiah",
    lang65: "Persyaratan Poin",
    lang66: "Poin yang Tercapai",
    lang67: "Tersedia untuk Diklaim",
    lang68: "Penukaran Poin Berhasil",
    lang69: "Menyukai",
    lang70: "memuji",
    lang71: "Anda sudah mengambil poin hari ini",
  } /* 合作联系 */,

  cooperate: {
    lang1: "Pesan Anda telah berhasil dikirim!",
    lang2: "Nama panggilan Anda",
    lang3: "Media kontak:",
    lang4: "Info kontak:",
    lang5:
      "Terima kasih banyak atas pesan kerja sama dan saran Anda untuk pertumbuhan FIREFLY. Staf kami akan menghubungi Anda. Harap perhatikan informasi kontak yang Anda tinggalkan.",
    lang6: "Pengantar kerja sama host",
    lang7: "Lihat beranda utusan",
    lang8: "Kembali ke beranda",
    lang9:
      "Host FIREFLY, pengundang pengguna, atau anggota serikat yang menjadi utusan dapat menjalin hubungan korespondensi dengan orang yang mereka undang dan menerima hadiah jangka panjang. Utusan yang luar biasa juga akan secara otomatis mendapatkan hak istimewa di komunitas.",
    lang10: "Tinggalkan info kontak Anda",
    lang11: "Tinggalkan info kontak alternatif Anda (opsional)",
    lang12: "Pesan Anda untuk FIREFLY",
    lang13: "Silakan masukkan pesan Anda untuk FIREFLY",
    lang14: "Konfirmasi pengiriman",
    lang15: "Pilih media kontak",
    lang16: "Wechat",
    lang17: "Kerja sama Host",
    lang18: "Host independen bergabung dengan FIREFLY sendiri",
    lang19: "Kerja sama Utusan",
    lang20: "Bergabung dengan FIREFLY sebagai serikat",
    lang21: "Kerja Sama Bisnis",
    lang22: "Promosi dan Media",
    lang23: "Umpan Balik Pemain",
    lang24: "Saluran pengiriman umpan balik pemain FIREFLY",
    lang25: "Kontak Kerja Sama",
    lang26: "Silakan masukkan ID FIREFLY Anda",
    lang27: "Silakan masukkan ID Whatsapp Anda",
    lang28: "Silakan masukkan ID Telegram Anda",
    lang29: "Silakan masukkan ID Facebook Anda",
    lang30: "Silakan masukkan Email Anda",
    lang31: "Silakan masukkan Wechat Anda",
    lang32: "Silakan masukkan Line Anda",
    lang33: "Silakan coba lagi nanti",
    lang34: "Silakan masukkan nama panggilan Anda",
    lang35: "Silakan masukkan info kontak Anda",
    lang36: "Silakan masukkan pesan Anda",
  },
  premiumNumberCommitLetter: {
    lang1: "Surat Komitmen Aktivasi Nomor Cantik",
    lang2: "Yth. ",
    lang3: "ID asli: ",
    lang4: "Nomor cantik yang Anda ajukan ",
    lang5:
      "akan segera diaktifkan untuk Anda. Demi menjaga ketertiban platform dan keamanan akun, mohon baca dan setujui ketentuan berikut:",
    lang6:
      "Nomor cantik yang Anda peroleh adalah sumber daya langka dan tidak dapat diperbarui di komunitas FIREFLY. Transfer jenis akun ini dapat berdampak negatif pada stabilitas dan struktur komunitas.",
    lang7: "[Ketentuan Komitmen]",
    lang8:
      "1. Saya berjanji nomor cantik ini hanya untuk penggunaan pribadi dan tidak akan diberikan kepada pihak ketiga dalam bentuk apa pun, termasuk namun tidak terbatas pada penjualan, penyewaan, hadiah, atau pengalihan.",
    lang9:
      "2. Saya memahami bahwa jika melanggar komitmen di atas, platform berhak menarik nomor cantik ini dan dapat memberlakukan pembatasan pada akun asli seperti pemblokiran atau penurunan hak.",
    lang10:
      "3. Saya berjanji untuk mematuhi perjanjian pengguna platform dan hukum yang berlaku, serta tidak menggunakan nomor cantik untuk pelanggaran atau tindakan ilegal.",
    lang11:
      "Komitmen ini menjadi mengikat setelah ditandatangani. Terima kasih atas pengertian dan kerja sama Anda.",
    lang12: "Saya Tidak Setuju",
    lang13: "Saya Setuju",
    lang14: "Pengguna Telah Setuju",
    lang15: "Waktu Persetujuan: ",
    lang16: "Permohonan Migrasi Diajukan",
    lang17:
      "Waktu migrasi spesifik akan diinformasikan oleh layanan pelanggan khusus. Terima kasih atas pengertian dan dukungan Anda.",
    lang18: "Mengerti",
    lang19:
      "Permohonan Anda telah berhasil diajukan. Terima kasih atas pengertian dan dukungan Anda.",
    lang20: "Segarkan",
    lang21: "Layanan Pelanggan",
    lang22: "Tutup Halaman",
    lang23: "Lainnya",
  },
  vipUpPublicNotice: {
    lang1:
      "Untuk memberikan pengalaman interaksi yang lebih eksklusif, kami akan meluncurkan sistem level VIP baru pada ",
    lang2: "2026/8/4",
    lang3: "Level Premium Baru Resmi Diluncurkan",
    lang4:
      "Pembaruan ini menyesuaikan poin kekayaan yang diperlukan untuk beberapa level VIP dan menambahkan manfaat serta hak istimewa yang lebih kaya. Perubahan utama adalah sebagai berikut:",
    lang5: "Setelah sistem baru online, level kekayaan asli Anda akan ",
    lang6: "secara otomatis diwariskan berdasarkan poin kekayaan",
    lang7: " ke level VIP yang sesuai dalam sistem baru.",
    lang8:
      "Contoh: Jika level Anda sebelumnya VIP43 dengan 3.254.120 poin, maka akan diwariskan menjadi VIP45. Poin tidak berubah dan Anda akan mendapatkan hak istimewa VIP terkait.",
    lang9: "Jenis Hak Istimewa",
    lang10: "Detail Hak Istimewa",
    lang11: "Level Pembukaan",
    lang12: "Sembunyikan Identitas",
    lang13: "Mode Tak Terlihat",
    lang14: "Pengecualian Admin",
    lang15: "Perlindungan dari tendang dan bisu",
    lang16: "Kendaraan Pribadi",
    lang17: "Kendaraan eksklusif kustom",
    lang18: "Sistem Nomor Cantik",
    lang19: "Nomor cantik 6/5/4 digit",
    lang20: "Barrage Berwarna",
    lang21: "Kustomisasi 3/5 warna",
    lang22: "Layanan Eksklusif",
    lang23: "Kanal layanan pelanggan eksklusif",
    lang24: "Promo Top-up",
    lang25: "Kanal pengisian eksklusif",
    lang26: "Kartu Profil",
    lang27: "Latar kartu profil statis/dinamis",
    lang28: "Hadiah Kustom",
    lang29: "Hadiah menengah (5 dtk) / Hadiah tingkat lanjut (10 dtk)",
    lang30: "Pemberitahuan Seluruh Situs",
    lang31: "Pemberitahuan online seluruh situs",
    lang32: "Selama pengembangan platform, kami akan ",
    lang33: "terus menyempurnakan hak istimewa VIP dan pengalaman layanan",
    lang34:
      ". Jika ada perubahan aturan atau manfaat, kami akan mengumumkannya tepat waktu. Mohon pantau.",
    lang35: "Firefly memiliki hak interpretasi akhir",
  },
  // Ludo
  ludo: {
    clubPkRoom: "Ruang PK {club}",
    lang1: "Buka Room",
    lang2: "Gabung Cepat",
    lang3: "Masuk",
    lang4: "Menunggu",
    lang5: "Saat ini tidak ada room Ludo PK",
    lang6: "Mode Permainan",
    lang7: "Klub Default",
    lang8: "Klasik",
    lang9: "Tanpa Batas",
    lang10: "Rekor",
    lang11: "Peringkat",
    lang12: "Dew Masuk",
    lang13: "Info Permainan",
    lang16: "Bayar dew masuk untuk bergabung ke Ludo PK",
    lang17: "Jumlah Pemain",
    lang18: "Hadiah Kemenangan",
    lang19: "Reputasi",
    lang20: "Prop Saya",
    lang21: "Bidak",
    lang22: "Papan",
    lang23: "Pilih prop bidak yang akan Anda gunakan di permainan LUDO.",
    lang24: "Pilih prop papan untuk room PK klub Anda di permainan LUDO.",
    lang25: "Lencana Waktu",
    lang26: "Dipilih",
    lang27: "Default",
    lang28: "Silakan pilih prop",
    lang31: "Gunakan",
    lang32: "Klik untuk memilih prop yang akan digunakan",
    lang33:
      "Klik untuk menggunakan, permainan LUDO berikutnya akan memakai prop papan ini",
    lang34:
      "Klik untuk menggunakan, permainan LUDO berikutnya akan memakai prop bidak ini",
    lang35: "Sedang digunakan",
    lang36: "Silakan pilih prop yang akan digunakan",
    lang37: "Berhasil digunakan, akan berlaku di permainan LUDO berikutnya",
    lang38: "hari",
    lang39: "jam",
    lang40: "menit",
    lang42: "Saat ini tidak ada catatan LUDO PK",
    lang43: "Detail Permainan",
    lang45: "Biaya Room",
    lang46: "Waktu",
    lang47: "Dew",
    lang49: "Tanggal",
    lang50: "Total",
    lang51: "Avatar Pemain",
    lang52: "Peringkat",
    lang53: "Peringkat 1",
    lang54: "Peringkat 2",
    lang55: "Peringkat 3",
    lang56: "Peringkat 4",
    lang57: "Memuat...",
    lang58: "Layanan Pelanggan",
    lang59: "Menang",
    lang60: "Kalah",
    lang61: "Seri",
    lang62: "Petunjuk Permainan",
    lang63: "Aturan Permainan",
    lang64: "Jumlah Pemain",
    lang66: "Penentuan Menang Kalah",
    lang68: "Reputasi Klub",
    lang69: "Ikut Permainan",
    lang70: "Masuk di Tengah Permainan",
    lang72: "Lepas Landas",
    lang73: "Tiga Enam Beruntun",
    lang74: "Bergerak",
    lang75: "Tumpukan Bidak",
    lang76: "Makan Bidak",
    lang77: "Zona Aman",
    lang78: "2-4 pemain",
    lang79:
      "Klasik: Semua bidak pemain harus mulai dari titik awal, mengelilingi papan satu putaran, lalu mencapai garis akhir. Jika semua bidak mencapai akhir, permainan dianggap selesai. Semakin cepat selesai, semakin tinggi peringkatnya.",
    lang80:
      "Sesuai mode permainan, pemain yang lebih dulu menyelesaikan permainan akan mendapat peringkat lebih tinggi. Misalnya, pemain pertama yang selesai akan menjadi peringkat 1 di permainan ini, dan seterusnya.",
    lang81:
      "Setelah permainan berakhir, Anda bisa mendapatkan hadiah dew dan reputasi sesuai peringkat Anda.",
    lang82:
      "Jika Anda memenangkan permainan di room klub yang telah Anda masuki, reputasi Anda di klub tersebut akan bertambah sesuai peringkat permainan.",
    lang83:
      "Bayar dew masuk yang ditentukan pemilik room untuk bergabung ke permainan.",
    lang84:
      "Dalam permainan yang sudah dimulai, pemain dapat membayar dew masuk untuk bergabung ke Ludo PK di tengah permainan.",
    lang85:
      "Anda harus melempar angka enam agar bidak bisa lepas landas dari markas ke kotak awal.",
    lang86:
      "Jika dalam giliran yang sama keluar angka enam sebanyak 3 kali, maka tiga enam beruntun akan terpicu dan pemain melewati giliran ini.",
    lang87:
      "Pemain melempar dadu untuk mendapatkan angka dan menggerakkan bidak maju sesuai jumlah langkah yang didapat.",
    lang88:
      "Bidak milik pemain yang sama yang berhenti di tempat yang sama akan menjadi tumpukan bidak. Jika dimakan, semua bidak dalam tumpukan akan ditendang kembali ke markas.",
    lang89:
      "Jika setelah bergerak bidak berhenti di petak yang memiliki bidak pemain lain, semua bidak pemain lain tersebut akan ditendang kembali ke markas dan harus lepas landas lagi untuk bergerak.",
    lang90:
      "Bidak yang mendarat di titik awal atau petak bershield di papan tidak bisa dimakan. Bidak dari pemain berbeda dapat berhenti bersama di petak tersebut.",
    lang91:
      "Setiap permainan akan mengenakan sejumlah dew tetap sebagai biaya room. Besarnya biaya room ditentukan berdasarkan jumlah dew masuk dan tidak terkait dengan jumlah pemain. Saat hadiah dew dibagikan pada akhir permainan, sistem akan otomatis memotong biaya room terlebih dahulu sebelum memberikan hadiah dew kepada pemenang.",
    lang92: "Ikut Permainan",
    lang93: "Biaya Room Game",
    lang94: "Kemenangan",
    lang95: "Pemain",
    lang96: "Dew Penyelesaian",
    lang97: "Biaya Pertandingan",
    lang98: "Taruhan Dasar",
    lang99: "/permainan",
    lang100: "Hasil saya",
    lang101: "Pemain",
    lang102: "Riwayat",
  },
  teenPatti: {
    recordTitle: "Riwayat",
    rankingTitle: "Papan Peringkat",
    confirm: "Konfirmasi",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "Pengaturan Permainan",
    maxBet: "Taruhan Embun Maksimum",
    maxPot: "Pot Maksimum",
    buyInDew: "Embun untuk Masuk",
    mockJoinTip: "Demo: embun dasar {ante} dipilih. Fitur bergabung belum terhubung.",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "Ruang PK {club}",
    // 三张牌规则页文案：暂沿用此前的英文回退内容，待补充本语言翻译。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "Embun Dasar",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "Buka Room",
    lang2: "Gabung Cepat",
    lang3: "Masuk",
    lang4: "Menunggu",
    lang5: "Saat ini tidak ada room Teen Patti PK",
    lang6: "Mode Permainan",
    lang7: "Klub Default",
    lang8: "Klasik",
    lang9: "Tanpa Batas",
    lang10: "Rekor",
    lang11: "Peringkat",
    lang12: "Dew Masuk",
    lang13: "Info Permainan",
    lang16: "Bayar dew masuk untuk bergabung ke Ludo PK",
    lang17: "Jumlah Pemain",
    lang18: "Hadiah Kemenangan",
    lang19: "Reputasi",
    lang20: "Prop Saya",
    lang21: "Bidak",
    lang22: "Papan",
    lang23: "Pilih prop bidak yang akan Anda gunakan di permainan LUDO.",
    lang24: "Pilih prop papan untuk room PK klub Anda di permainan LUDO.",
    lang25: "Lencana Waktu",
    lang26: "Dipilih",
    lang27: "Default",
    lang28: "Silakan pilih prop",
    lang31: "Gunakan",
    lang32: "Klik untuk memilih prop yang akan digunakan",
    lang33:
      "Klik untuk menggunakan, permainan LUDO berikutnya akan memakai prop papan ini",
    lang34:
      "Klik untuk menggunakan, permainan LUDO berikutnya akan memakai prop bidak ini",
    lang35: "Sedang digunakan",
    lang36: "Silakan pilih prop yang akan digunakan",
    lang37: "Berhasil digunakan, akan berlaku di permainan LUDO berikutnya",
    lang38: "hari",
    lang39: "jam",
    lang40: "menit",
    lang42: "Saat ini tidak ada catatan Teenpatti PK",
    lang43: "Detail Permainan",
    lang45: "Biaya Room",
    lang46: "Waktu",
    lang47: "Dew",
    lang49: "Tanggal",
    lang50: "Total",
    lang51: "Avatar Pemain",
    lang52: "Peringkat",
    lang53: "Peringkat 1",
    lang54: "Peringkat 2",
    lang55: "Peringkat 3",
    lang56: "Peringkat 4",
    lang57: "Memuat...",
    lang58: "Layanan Pelanggan",
    lang59: "Menang",
    lang60: "Kalah",
    lang61: "Seri",
    lang62: "Petunjuk Permainan",
    lang63: "Aturan Permainan",
    lang64: "Jumlah Pemain",
    lang66: "Penentuan Menang Kalah",
    lang68: "Reputasi Klub",
    lang69: "Ikut Permainan",
    lang70: "Masuk di Tengah Permainan",
    lang72: "Lepas Landas",
    lang73: "Tiga Enam Beruntun",
    lang74: "Bergerak",
    lang75: "Tumpukan Bidak",
    lang76: "Makan Bidak",
    lang77: "Zona Aman",
    lang78: "2-4 pemain",
    lang79:
      "Klasik: Semua bidak pemain harus mulai dari titik awal, mengelilingi papan satu putaran, lalu mencapai garis akhir. Jika semua bidak mencapai akhir, permainan dianggap selesai. Semakin cepat selesai, semakin tinggi peringkatnya.",
    lang80:
      "Sesuai mode permainan, pemain yang lebih dulu menyelesaikan permainan akan mendapat peringkat lebih tinggi. Misalnya, pemain pertama yang selesai akan menjadi peringkat 1 di permainan ini, dan seterusnya.",
    lang81:
      "Setelah permainan berakhir, Anda bisa mendapatkan hadiah dew dan reputasi sesuai peringkat Anda.",
    lang82:
      "Jika Anda memenangkan permainan di room klub yang telah Anda masuki, reputasi Anda di klub tersebut akan bertambah sesuai peringkat permainan.",
    lang83:
      "Bayar dew masuk yang ditentukan pemilik room untuk bergabung ke permainan.",
    lang84:
      "Dalam permainan yang sudah dimulai, pemain dapat membayar dew masuk untuk bergabung ke Ludo PK di tengah permainan.",
    lang85:
      "Anda harus melempar angka enam agar bidak bisa lepas landas dari markas ke kotak awal.",
    lang86:
      "Jika dalam giliran yang sama keluar angka enam sebanyak 3 kali, maka tiga enam beruntun akan terpicu dan pemain melewati giliran ini.",
    lang87:
      "Pemain melempar dadu untuk mendapatkan angka dan menggerakkan bidak maju sesuai jumlah langkah yang didapat.",
    lang88:
      "Bidak milik pemain yang sama yang berhenti di tempat yang sama akan menjadi tumpukan bidak. Jika dimakan, semua bidak dalam tumpukan akan ditendang kembali ke markas.",
    lang89:
      "Jika setelah bergerak bidak berhenti di petak yang memiliki bidak pemain lain, semua bidak pemain lain tersebut akan ditendang kembali ke markas dan harus lepas landas lagi untuk bergerak.",
    lang90:
      "Bidak yang mendarat di titik awal atau petak bershield di papan tidak bisa dimakan. Bidak dari pemain berbeda dapat berhenti bersama di petak tersebut.",
    lang91:
      "Setiap permainan akan mengenakan sejumlah dew tetap sebagai biaya room. Besarnya biaya room ditentukan berdasarkan jumlah dew masuk dan tidak terkait dengan jumlah pemain. Saat hadiah dew dibagikan pada akhir permainan, sistem akan otomatis memotong biaya room terlebih dahulu sebelum memberikan hadiah dew kepada pemenang.",
    lang92: "Ikut Permainan",
    lang93: "Biaya Room Game",
    lang94: "Kemenangan",
    lang95: "Pemain",
    lang96: "Dew Penyelesaian",
    lang97: "Biaya Pertandingan",
    lang98: "Embun Dasar",
  },
};
